// Path: ./src/app/pages/CreateCoupon/styled.ts
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;

export const Logo = styled.img`
  height: 110px;
  @media screen and (max-width: 480px) {
    height: 70px;
  }
`;

export const Text = styled.h1`
  font-size: 25px;
  font-weight: bold;
  margin-top: 0px;
  font-style: italic;
  text-align: center;
  @media screen and (max-width: 480px) {
    font-size: 20px;
  }
`;
